import React from 'react';
import './CaFooter.css';

const CaFooter = () => {
  return (
    <footer className="ca-footer">
      <div className="ca-footer__container">
        {/* Left Side: Logo */}
        <div className="ca-footer__logo-box">
          <a href="/ca/" aria-label="Al Quran Lesson">
            <img
              src={`${process.env.PUBLIC_URL}/assets/images/FooterLogo.png`}
              alt="Al Quran Lesson"
              className="ca-footer__logo-img"
            />
          </a>
        </div>

        {/* Right Side: Privacy Policy Link */}
        <div className="ca-footer__right">
          <a href="/privacy-policy/" className="ca-footer__link">
            PRIVACY POLICY
          </a>
        </div>
      </div>
    </footer>
  );
};

export default CaFooter;
